import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
  Stack,
  useTheme,
} from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Link as RouterLink } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import siteConfig from '../config/siteConfig'; // Import siteConfig

const Footer = () => {
  const theme = useTheme();
  const { language, translations } = useLanguage();
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { text: translations.aboutUs[language], path: '/about' },
   // { text: translations.services[language], path: '/services' },
    { text: translations.schemes[language], path: '/schemes' },
    { text: translations.contact[language], path: '/contact' },
  ];

  const socialLinks = [
    { icon: <FacebookIcon />, url: 'https://facebook.com' },
    { icon: <TwitterIcon />, url: 'https://twitter.com' },
    { icon: <InstagramIcon />, url: 'https://instagram.com' },
    { icon: <YouTubeIcon />, url: 'https://youtube.com' },
  ];

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: siteConfig.footer.backgroundColor,
        color: siteConfig.footer.backgroundColor === '#16404D' ? '#fff' : siteConfig.colors.footerText,
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* About Section */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>{siteConfig.footer.title}</Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>{siteConfig.footer.subtext}</Typography>
          </Grid>

          {/* Quick Links Section */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              {translations.usefulLinks[language]}
            </Typography>
            <Stack spacing={1}>
              {quickLinks.map((link) => (
                <Link
                  key={link.path}
                  component={RouterLink}
                  to={link.path}
                  color="inherit"
                  sx={{ 
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' }
                  }}
                >
                  {link.text}
                </Link>
              ))}
            </Stack>
          </Grid>

          {/* Social Links Section */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              {translations.followUs[language]}
            </Typography>
            <Stack direction="row" spacing={1}>
              {socialLinks.map((link, index) => (
                <IconButton
                  key={index}
                  component="a"
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ 
                    color: siteConfig.footer.backgroundColor === '#16404D' ? '#fff' : siteConfig.colors.footerText, 
                    '&:hover': { 
                      bgcolor: 'rgba(255, 255, 255, 0.1)'
                    }
                  }}
                >
                  {link.icon}
                </IconButton>
              ))}
            </Stack>
          </Grid>
        </Grid>

        {/* Copyright Section
        <Box sx={{ bgcolor: '#16404D', color: siteConfig.colors.footerText, p: 3 }}>
          <Typography variant="body2">
            {translations.copyright[language]} {currentYear} | Pargaon Grampanchayat
          </Typography>
        </Box> */}
      </Container>
    </Box>
  );
};

export default Footer;
